import React, { useState } from "react";
import PropTypes from "prop-types";

import { Field, Control, Label, Input } from "rbx";
import { BooleanInput, ItemCategorySelect } from "../../../components/inputs";

import FilterButtons from "../../../components/FilterButtons";

const INITIAL_FILTER_STATE = {
  Active: true
};
function ItemFilters({ filters, onFilter, onClose, onReset }) {
  const [inputs, setInputs] = useState({ ...filters });

  const handleChange = e => {
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    const updates = { ...inputs };
    if (e.target.name.includes("RecIdRef")) {
      updates[e.target.name] = parseInt(value);
    } else {
      updates[e.target.name] = value;
    }
    setInputs({ ...updates });
  };

  const handleClose = () => onClose(onFilter(inputs));
  const handleCancel = () => onClose(onFilter(filters));
  const handleReset = () =>
    onReset ? onReset() : onClose(onFilter({ ...INITIAL_FILTER_STATE }));

  return (
    <div style={{ width: 600, maxWidth: "80vw" }}>
      <Field kind="group">
        <Control expanded>
          <ItemCategorySelect
            icon="globe"
            label="Item Category"
            name="ItemCatgRecIdRef"
            value={inputs.ItemCatgRecIdRef}
            onChange={handleChange}
          />
        </Control>
        <Control>
          <Label>Active</Label>
          <BooleanInput
            name="Active"
            value={inputs.Active}
            onChange={handleChange}
          />
        </Control>
      </Field>
      <Field kind="group">
        <Control expanded>
          <Label>Item No</Label>
          <Input
            name="ItemNo_contains"
            type="text"
            value={inputs.ItemNo_contains}
            onChange={handleChange}
          />
        </Control>
        <Control expanded>
          <Label>Item Description</Label>
          <Input
            name="Description_contains"
            type="text"
            value={inputs.Description_contains}
            onChange={handleChange}
          />
        </Control>
      </Field>
      <hr />
      <FilterButtons
        handleCancel={handleCancel}
        handleClose={handleClose}
        handleReset={handleReset}
      />
    </div>
  );
}
ItemFilters.propTypes = {
  filters: PropTypes.object,
  onFilter: PropTypes.func,
  onClose: PropTypes.func,
  onReset: PropTypes.func
};
ItemFilters.defaultProps = {
  filters: {}
};
export default ItemFilters;
